import {
  Card,
  CardsWrapper,
  Container,
  Content,
} from "../styles";

import { CircularProgress } from "@mui/material";
import useCallAxios from "../../../../Hooks/useCallAxios";
import { formatCurrency } from "../../../../Utils/formatters";

interface InvoiceSummaryProps {
  invoices: any[];
  limit: number;
}

export const InvoiceSummary = ({ invoices, limit }: InvoiceSummaryProps) => {
  const totalValue = invoices.reduce((sum, nf) => sum + (nf.vOrig || 0), 0);

  const context = "invoicesValidation";

  const {
    requestLoading: loading,
  } = useCallAxios({ context });

  return (
    <Container>
      <CardsWrapper>
        <Card>
          <p>Valor Notas Fiscais</p>
          <Content>
            {loading.POST ? (
              <CircularProgress style={{ verticalAlign: "sub" }} />
            ) : (
              <p>{formatCurrency(totalValue, "BRL", 0)}</p>
            )}
          </Content>
        </Card>
        <Card>
          <p>Quantidade de Notas</p>
          <Content>
            {loading.POST ? (
              <CircularProgress style={{ verticalAlign: "sub" }} />
            ) : (
              <p>{invoices.length}</p>
            )}
          </Content>
        </Card>
        <Card>
          <p>Limite Disponível</p>
          <Content>
            {loading.POST ? (
              <CircularProgress style={{ verticalAlign: "sub" }} />
            ) : (
              <p>{formatCurrency(limit, "BRL", 0)}</p>
            )}
          </Content>
        </Card>
      </CardsWrapper>
    </Container>
  );
};
